import {
  TRACEABILITY_SET_DESTINATIONS,
  TRACEABILITY_SET_LOADING_STATUS_TOTAL_DESTINATION,
  TRACEABILITY_SET_LOADING_STATUS_TOTAL,
  TRACEABILITY_SUM_ALL_SAMPLES_DESTINATIONS,
  TRACEABILITY_SET_ALL_TOTAL_STATUS,
  TRACEABILITY_CLEAR_ALL_TOTAL_STATUS,
} from '../types'
import traceabilityStatisticsService from '../../api/traceabilityStatistics'

const state = {
  samplesPerDestinations: [],
  loadingStatusFromSamplesPerPlaceExecution: 'STATUS_INITIAL',
  loadingStatusFromTotalCounters: 'STATUS_INITIAL',
  totalSamplesWaitingForTransport: 0,
  totalSamplesInTransit: 0,
  totalSamplesInScreening: 0,
  totalSamplesAtExecution: 0,
  totalReleased: 0,
  totalAheadSchedule: 0,
  totalDelayedExamsCount: 0,
  totalSamplesReady: 0,
}

const mutations = {
  [TRACEABILITY_SET_DESTINATIONS](state, destinations) {
    state.samplesPerDestinations = destinations
  },
  [TRACEABILITY_SET_LOADING_STATUS_TOTAL_DESTINATION](state, status) {
    state.loadingStatusFromSamplesPerPlaceExecution = status
  },
  [TRACEABILITY_SET_LOADING_STATUS_TOTAL](state, status) {
    state.loadingStatusFromTotalCounters = status
  },
  [TRACEABILITY_SUM_ALL_SAMPLES_DESTINATIONS](state) {
    if (state.samplesPerDestinations.length > 0) {
      state.totalSamplesInTransit = state.samplesPerDestinations.reduce(function (a, b) {
        return a + b.samplesCount
      }, 0)
    } else {
      state.totalSamplesInTransit = 0
    }
  },
  [TRACEABILITY_SET_ALL_TOTAL_STATUS](state, status) {
    state.totalSamplesInScreening = status.deliveryToNTO
    state.totalSamplesAtExecution = status.inExecution
    state.totalReleased = status.released
    state.totalAheadSchedule = status.aheadSchedule
    state.totalDelayedExamsCount = status.behindSchedule
  },
  [TRACEABILITY_CLEAR_ALL_TOTAL_STATUS](state) {
    state.totalSamplesWaitingForTransport = 0
    state.totalSamplesInScreening = 0
    state.totalSamplesAtExecution = 0
    state.totalReleased = 0
    state.totalAheadSchedule = 0
    state.totalSamplesInTransit = 0
    state.samplesPerDestinations = []
  },
}

const getters = {
  samplesPerDestinations: state => {
    return state.samplesPerDestinations
  },
  loadingStatusFromSamplesPerPlaceExecution: state => {
    return state.LoadingStatusOfSamplesGoingToNTO
  },
  totalSamplesWaitingForTransport: state => {
    return state.totalSamplesWaitingForTransport
  },
  loadingStatusFromTotalCounters: state => {
    return state.loadingStatusFromTotalCounters
  },
  totalSamplesInExternalTraceability: state => {
    return state.totalSamplesInTransit + state.totalSamplesWaitingForTransport
  },
  totalSamplesInScreening: state => {
    return state.totalSamplesInScreening
  },
  totalSamplesAtExecution: state => {
    return state.totalSamplesAtExecution
  },
  totalReleased: state => {
    return state.totalReleased
  },
  totalAheadSchedule: state => {
    return state.totalAheadSchedule
  },
  totalDelayedExamsCount: state => {
    return state.totalDelayedExamsCount
  },
  totalSamplesReady: state => {
    return state.totalSamplesReady
  },
}

const actions = {
  getTotalDestinations: function ({ commit }, filters) {
    commit(TRACEABILITY_SET_LOADING_STATUS_TOTAL_DESTINATION, 'STATUS_LOADING')

    return traceabilityStatisticsService
      .getTotalSamplesGoingToPlaceExecution(filters)
      .then(response => {
        commit(TRACEABILITY_SET_LOADING_STATUS_TOTAL_DESTINATION, 'STATUS_SUCCESS')
        commit(TRACEABILITY_SET_DESTINATIONS, response.data)
        commit(TRACEABILITY_SUM_ALL_SAMPLES_DESTINATIONS)
      })
      .catch(() => {
        commit(TRACEABILITY_SET_LOADING_STATUS_TOTAL_DESTINATION, 'STATUS_FAILED')
        commit(TRACEABILITY_SET_DESTINATIONS, [])
        commit(TRACEABILITY_SUM_ALL_SAMPLES_DESTINATIONS)
      })
  },
  getTotalTraceabilityStatus: function ({ commit }, filters = {}) {
    commit(TRACEABILITY_SET_LOADING_STATUS_TOTAL, 'STATUS_LOADING')

    return traceabilityStatisticsService
      .getTraceabilityTotalStatus(filters)
      .then(response => {
        commit(TRACEABILITY_SET_ALL_TOTAL_STATUS, response.data)
        commit(TRACEABILITY_SET_LOADING_STATUS_TOTAL, 'STATUS_SUCCESS')
      })
      .catch(() => {
        commit(TRACEABILITY_CLEAR_ALL_TOTAL_STATUS)
        commit(TRACEABILITY_SET_LOADING_STATUS_TOTAL, 'STATUS_FAILED')
      })
  },
  clearAllTraceabilityData: function ({ commit }) {
    commit(TRACEABILITY_CLEAR_ALL_TOTAL_STATUS)
  },
}

export default {
  state,
  mutations,
  actions,
  getters,
}
export { mutations, actions, getters }
